export const MAX_RAID_SIZE = 40;
export const MAX_PARTY_SIZE = 5;
